import { render, staticRenderFns } from "./Amazoncategories.vue?vue&type=template&id=b0c7dcd0"
import script from "./Amazoncategories.vue?vue&type=script&lang=js"
export * from "./Amazoncategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports